import { createContext } from 'react';

export const TeamContext = createContext();
export const ServiceContext = createContext(); // Create ServicesContext